export enum SocketMessage_Enum {
  ApplicationStateChanged = 0,
  AdvisorSavedVehicle = 1,
  DocumentUploadApproved = 2,
  VehicleAvailabilityChecked = 3,
  DealReviewed = 4,
  EsignAvailable = 5,
}
